module.exports = __webpack_public_path__ + "img/modificationOrder.7e7b0c5e.svg";